const LIST_TRANSITION_DURATION = 200;
const ENTER_TRANSITION_DURATION_MS = 200;
const portalsCls = "_275p726s4x";
const transitionCls = "_275t1fgehiw";
const listCls = "_275lrwpbm7";
const select = "_275s1ed3p49";

export { ENTER_TRANSITION_DURATION_MS, LIST_TRANSITION_DURATION, listCls, portalsCls, select, transitionCls };
import "./page.style.linaria.module.css";
//# sourceMappingURL=page.style.js.map
